import React from 'react'

export const DistrictContext = React.createContext({})